import { render, staticRenderFns } from "./Bloqueo.vue?vue&type=template&id=b9655212&scoped=true&"
import script from "./Bloqueo.vue?vue&type=script&lang=js&"
export * from "./Bloqueo.vue?vue&type=script&lang=js&"
import style0 from "./Bloqueo.vue?vue&type=style&index=0&id=b9655212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9655212",
  null
  
)

export default component.exports